import { toPlatePlugin } from '@udecode/plate/react';

import { BaseHorizontalRulePlugin } from '../lib';

export const HorizontalRulePlugin = toPlatePlugin(BaseHorizontalRulePlugin);
